/* eslint-disable no-console */

/**
 * Wraps over `console` to make it usable during development while preventing the output in production.
 * This lets us commit `console` usage whereever we might need it permanently.
 * @file
 */

/**
 * @type {boolean}
 */
const isProduction = process.env.NODE_ENV === 'production'

export function assert(expression, message) {
  if (!isProduction) {
    console.assert(expression, message)
  }
}

export function clear() {
  if (!isProduction) {
    console.clear()
  }
}

export function count(title) {
  if (!isProduction) {
    console.count(title)
  }
}

export function debug(message) {
  if (!isProduction) {
    console.debug(message)
  }
}

export function dir(object) {
  if (!isProduction) {
    console.dir(object)
  }
}

export function dirxml(object) {
  if (!isProduction) {
    console.dirxml(object)
  }
}

export function error() {
  if (!isProduction) {
    console.error(...arguments)
  }
}

export function group(title) {
  if (!isProduction) {
    console.group(title)
  }
}

export function groupCollapsed(title) {
  if (!isProduction) {
    console.groupCollapsed(title)
  }
}

export function groupEnd() {
  if (!isProduction) {
    console.groupEnd()
  }
}

export function info() {
  if (!isProduction) {
    console.info(...arguments)
  }
}

export function log() {
  if (!isProduction) {
    console.log(...arguments)
  }
}

export function select(element) {
  if (!isProduction) {
    console.select(element)
  }
}

export function time(name) {
  if (!isProduction) {
    console.time(name)
  }
}

export function timeEnd(name) {
  if (!isProduction) {
    console.timeEnd(name)
  }
}

export function trace() {
  if (!isProduction) {
    console.trace()
  }
}

export function warn() {
  if (!isProduction) {
    console.warn(...arguments)
  }
}

export default {
  assert,
  clear,
  count,
  debug,
  dir,
  dirxml,
  error,
  group,
  groupCollapsed,
  groupEnd,
  info,
  log,
  select,
  time,
  timeEnd,
  trace,
  warn,
}
